import IActionsResolver from 'globx/dist/Store/Interfaces/IActionsResolver';
import {Subject}        from 'rxjs';

import InteractionType     from '../../../Analytics/Interactions/Constants/InteractionType';
import IInteractionPayload from '../../../Analytics/Interactions/Interfaces/IInteractionPayload';

import ControlsStatus  from './Constants/ControlsStatus';
import FrameStatus     from './Constants/FrameStatus';
import WatermarkStatus from './Constants/WatermarkStatus';
import Frame           from './Frame';
import IFrameActions   from './Interfaces/IFrameActions';

const createFrameActionsResolver = (
    interactions$: Subject<IInteractionPayload>
): IActionsResolver<Frame, IFrameActions> => (
    value: Frame,
    actions: IFrameActions
): IFrameActions => ({
    idleControls(): void {
        value.controlsStatus = ControlsStatus.IDLE;
    },

    activateControls(): void {
        value.controlsStatus = ControlsStatus.ACTIVE;
    },

    enterFullscreen(): void {
        value.frameStatus = FrameStatus.FULLSCREENED;

        interactions$.next({
            type: InteractionType.ENTER_FULLSCREEN
        });
    },

    exitFullscreen(): void {
        value.frameStatus = FrameStatus.WINDOWED;

        interactions$.next({
            type: InteractionType.EXIT_FULLSCREEN
        });
    },

    showWatermark(corner: WatermarkStatus): void {
        value.watermarkStatus = corner;
    },

    hideWatermark(): void {
        value.watermarkStatus = WatermarkStatus.HIDDEN;
    },

    focus(): void {
        value.isFocused = true;
    },

    blur(): void {
        value.isFocused = false;
    },

    openSettings(): void {
        value.isSettingsOpen = true;
    },

    closeSettings(): void {
        value.isSettingsOpen = false;

        actions.activateControls();
    }
});

export default createFrameActionsResolver;